export default "__VITE_PUBLIC_ASSET__837a9db1__"